import { Directive, Input, OnInit, OnDestroy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { StateParamService } from '../services/state-param.service';
import { Subject, takeUntil } from 'rxjs';

@Directive({
  selector: '[routerLink][preserveState]',
  standalone: true
})
export class StatePreservingRouterLinkDirective implements OnInit, OnDestroy {
  @Input() preserveState: boolean = true;
  
  private destroy$ = new Subject<void>();

  constructor(
    private routerLink: RouterLink,
    private stateParamService: StateParamService
  ) {}

  ngOnInit(): void {
    if (this.preserveState) {
      // Watch for state changes and update query params
      this.stateParamService.state$
        .pipe(takeUntil(this.destroy$))
        .subscribe(state => {
          if (state) {
            // Preserve existing query params and add/update state
            const currentQueryParams = this.routerLink.queryParams || {};
            this.routerLink.queryParams = {
              ...currentQueryParams,
              state: state
            };
            //@ts-ignore
          } else if (this.routerLink.queryParams?.state) {
            // Remove state if it no longer exists
            const { state: _, ...remainingParams } = this.routerLink.queryParams;
            this.routerLink.queryParams = remainingParams;
          }
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}